import { render } from "./review-view.vue?vue&type=template&id=c83f1182"
import script from "./review-view.vue?vue&type=script&lang=js"
export * from "./review-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__